import {notification} from "antd";

export const colors = {
    'orange': '#D84315',
    'darkOrange': '#F4511E',
    'lightWhite': '#F7F6F5',
    'dark': '#121212'
};

const APP_INDEX = '/shtepiaplus';
export const routes = {
    App: {
        Privacy: `/privacy`,
        Login: `/`,
        Home: '/home'
    }
};

export const baseUrl = 'https://api.shtepiaplus.com/'

export const errorHandler = (error) => {
    if (error.response.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/';
    } else if (error.response.status === 429) {
        notification.error({message: 'Too many request'})
    }



}







